<template lang="pug" functional>
	.matrixRow(:class="{edited: props.data[0]._edited, added: props.data[0]._added}")
		.matrixRow-inner(:style="props.cols")
			.matrixCell(
				v-for="(cell, i) in props.data",
				:key="cell._id",
				:data-label="props.labels[i]")
				span.matrixCell-content(v-html="cell._display")
			.matrixRow-crud
				i.matrixRow-crudTool.matrixRow-crudTool--move.fas.fa-grip-lines(v-if="props.sortable")
				i.matrixRow-crudTool.matrixRow-crudTool--edit.fas.fa-edit(@click="props.show('edit', props.data, null)")
				i.matrixRow-crudTool.matrixRow-crudTool--delete.fas.fa-minus-circle(@click="props.show('delete', props.data, null)")
		.matrixRow-add
			span.matrixRow-add-triger.fas.fa-plus-circle(@click="props.show('add', null, props.data[0]._row)")
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MatrixRowAdmin",
  // props: ["data", "labels", "cols", "sortable", "show"],
};
</script>

<style lang="scss" scoped>
.matrixRow-crud {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.matrixRow-crudTool {
  font-size: 20px;
  margin: 4px;
  cursor: pointer;
  &::before {
    margin-right: 0 !important;
  }
  &:hover {
    color: $empire;
  }
  &--move {
    cursor: grab;
  }
}

.matrixRow-add {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 0px;
  position: relative;
  z-index: 10;
  &::after {
    content: "";
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10px;
    transform: translateY(-50%);
  }
  &:hover {
    .matrixRow-add-triger {
      opacity: 1;
    }
  }
}

.matrixRow-add-triger {
  text-align: center;
  margin-right: 0 !important;
  font-size: 2rem;
  vertical-align: middle;
  z-index: 2;
  opacity: 0;
  cursor: pointer;
  &:hover {
    color: $empire;
  }
}
</style>